<template>
    <div class="profit-cancel-page">
        <!--        <p style="padding: 0 15px">-->
        <!--            <van-icon name="arrow-left"/>-->
        <!--        </p>-->
        <div class="user-info mission-container" style="min-height: 150px">
            <mission source="profit" :taskId="taskId" v-if="taskId">
                <div class="follow-info">
                    <img
                        :src="`https://wowoto.oss-cn-shanghai.aliyuncs.com/pinboo/${brandInfo.logo}`"
                        width="30"
                    />
                    <span>{{ brandInfo.name }}</span>
                    <span
                        ><img width="16" src="../../assets/jike/heart.png" />{{
                            brandInfo.attentionCount
                        }}
                        人关注</span
                    >
                </div>
            </mission>
        </div>
        <div class="publish-certify-wrapper">
            <template
                v-if="applyDetail.platform && applyDetail.platform.value === 50"
            >
                <p>发布链接</p>
                <a target="_blank" :href="applyDetail.submitUrl">{{
                    applyDetail.submitUrl
                }}</a>
            </template>
            <template v-else>
                <p>发布截图</p>
                <div v-if="images && images.length > 0">
                    <img
                        style="max-width: 100%; margin: 0 5px"
                        v-for="(img, index) in images"
                        :key="index"
                        :src="`https://wowoto.oss-cn-shanghai.aliyuncs.com/pinboo/${img}`"
                    />
                </div>
            </template>
        </div>
        <div class="cancel-opt-wrapper">
            <van-button
                :disabled="isDisabled"
                class="cancel-opt-wrapper-btn"
                @click="profitCancel"
                >权益核销</van-button
            >
        </div>
    </div>
</template>
<script>
import mission from "./components/mission";
import {
    fetchApply,
    fetchBrandById,
    profitCancel,
} from "../../services/instant";
import { fetchAuth } from "../../services/users";
import cloneDeep from "lodash.clonedeep";
import { Toast } from "vant";
import Cookies from "js-cookie";

export default {
    components: {
        mission,
    },
    data() {
        return {
            applyId: "",
            taskId: "",
            brandInfo: {},
            applyDetail: {},
            images: [],
            isDisabled: false,
        };
    },
    mounted() {
        const token = Cookies.get("token");
        if (token) {
            this.applyId = this.$route.params.id;
            fetchAuth(this.applyId)
                .then((res) => {
                    console.log("fetchAuth", res);
                    if (res) {
                        this.getApplyData();
                    } else {
                        this.$router.push("/profitFail");
                    }
                })
                .catch((err) => {
                    if (err.code === 1001) {
                        Cookies.remove("token");
                        Cookies.remove("secretKey");
                        this.goLogin();
                    }
                });
        } else {
            this.goLogin();
        }
        // const id = this.$route.params.id
        // 1435498102127419393
        // 1435170850256719874
    },
    methods: {
        getApplyData() {
            fetchApply(this.applyId)
                .then((res) => {
                    console.log(res, "fanhuiressssssssss");
                    this.applyDetail = cloneDeep(res.data.data);
                    if (this.applyDetail.platform.value === 60) {
                        console.log(
                            33333,
                            this.applyDetail.taskApplyKpi.supplemenImages
                        );
                        this.images = JSON.parse(
                            this.applyDetail.taskApplyKpi.supplemenImages
                        ).images;
                    }
                    this.taskId = res.data.data.taskId;
                    fetchBrandById(res.data.data.brandId).then((res) => {
                        console.log(res, "bbbbbbbbsssss");
                        this.brandInfo = res.data.data;
                    });
                    if (this.applyDetail.status.value === 100) {
                        Toast.fail("权益已核销");
                        this.isDisabled = true;
                    }
                })
                .catch((err) => {
                    // 登录超时的话，清除已有token,重新登录
                    if (err.code === 1001) {
                        Cookies.remove("token");
                        Cookies.remove("secretKey");
                        this.goLogin();
                    }
                });
        },
        goLogin() {
            const toPath = this.$route.path;
            this.$router.push(`/login?redirect=${toPath}`);
        },
        profitCancel() {
            profitCancel(this.applyId).then((res) => {
                if (res.data.code === 0) {
                    // this.$router.push('/profitSucceed')
                    Toast.success("核销成功");
                } else {
                    console.log(res, "msgggggggg");
                    Toast.fail(res.data.msg);
                }
            });
        },
        isAndroid() {
            // true代表Android端 false代表ios端
            const u = navigator.userAgent;
            const isAndroid =
                u.indexOf("Android") > -1 || u.indexOf("Linux") > -1; // android终端或者uc浏览器
            return isAndroid === true;
        },
        isIOS() {
            // true代表Android端 false代表ios端
            const u = navigator.userAgent;
            const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); // ios终端
            return isiOS === true;
        },
        wakeBaidu() {
            if (navigator.geolocation) {
                console.log("nihao");
                navigator.geolocation.getCurrentPosition((res) => {
                    console.log("你好");
                });
            } else {
                alert("该浏览器不支持定位");
            }
            // 29.539792,106.519852
            // 121.477075,31.258163
            // 121.451204,31.250445
            const latCurrent = 31.250445; // 获取到的纬度
            const lngCurrent = 121.451204; // 获取到的经度
            if (latCurrent && lngCurrent) {
                const urlObject = {
                    lat: 31.258163,
                    lng: 121.477075,
                    city: "上海",
                };
                let scheme = "";

                // urlObject 是我这边地址栏查询参数对象
                const queryStr =
                    "?origin=name:我的位置|latlng:" +
                    latCurrent +
                    "," +
                    lngCurrent +
                    "&destination=" +
                    urlObject.lat +
                    "," +
                    urlObject.lng +
                    "&region=" +
                    urlObject.city +
                    "&coord_type=bd09ll&mode=driving";

                if (this.isIOS()) {
                    // ios 端
                    scheme = "baidumap://map/direction" + queryStr;
                } else {
                    // android 端
                    scheme = "bdapp://map/direction" + queryStr;
                }

                console.log(scheme);
                // 主要实现代码
                // window.location.href = scheme

                var startTime = Date.now();
                var count = 0;
                var endTime = 0;

                var t = setInterval(function () {
                    count += 1;
                    endTime = Date.now() - startTime;
                    if (endTime > 6200) {
                        clearInterval(t);
                    }
                    if (count < 300) return;
                    if (!(document.hidden || document.webkitHidden)) {
                        console.log(33333333);
                        // window.location.href = 'http://api.map.baidu.com/direction' + queryStr + '&output=html'
                    }
                }, 20);

                window.onblur = function () {
                    clearInterval(t);
                };
            } else {
                alert("获取不到定位，请检查手机定位设置");
            }
        },
    },
};
</script>
<style lang="less" scoped>
.profit-cancel-page {
    //background: #F1F1F1;
    //padding: 0 15px;
    .publish-certify-wrapper {
        padding: 0 15px 15px;
        margin-bottom: 120px;
        p {
            font-size: 14px;
        }
        a {
            cursor: pointer;
            color: #013bff;
        }
    }
    .cancel-opt-wrapper {
        padding-top: 20px;
        height: 100px;
        position: fixed;
        width: 100%;
        bottom: 0;
        text-align: center;
        box-shadow: 0px -2px 4px 0px rgba(2, 4, 51, 0.08);
        background: #ffffff;
        &-btn {
            border-radius: 8px;
            margin: 0 auto 0;
            width: 330px;
            height: 50px;
            line-height: 50px;
            color: #ffffff;
            background: linear-gradient(180deg, #ff6d26 0%, #f7b500 100%);
        }
    }
    .user-info {
        padding: 10px 15px 0;
        border-bottom: 8px solid #f1f1f1;

        .follow-info {
            border-bottom: 1px solid #dadada;
            line-height: 40px;
            padding-bottom: 5px;

            img {
                vertical-align: middle;
                margin-right: 10px;
                border-radius: 100%;
            }

            span {
                &:nth-of-type(1) {
                    font-size: 14px;
                    font-weight: bold;
                    color: #000000;
                }

                &:nth-of-type(2) {
                    float: right;
                    font-size: 12px;
                }
            }
        }
    }
}
</style>
